import { inRange, isEmpty } from "lodash";
import React, { useContext } from "react";
import { useEffect } from "react";
import { useState } from "react";
import BetSlipContext from "../../context/BetSlipContext";
import BackandLay from "./BackandLay";
import Keyboard from "./Keyboard";
import { MarketLimits, marketRowStyles } from "./MarketHeader";

const MatchDetails = ({
  selections,
  back_odds,
  lay_odds,
  details,
  totalMatched,
  setSlipObj,
  setSelections,
  slipObj,
  handelBetFairPositions,
  resetSelection,
  setCondi,
  betType,
  profileData,
  user,
  messaageBox,
  betFairMs,
  setMarketDepth,
  marketId,
  marketName,
}) => {
  let { handelPlaceBetfair, betSelectionObj, betDelay } =
    useContext(BetSlipContext);
  // Desktop shows the full 3-deep back/lay ladder (reference exchange look);
  // mobile keeps the single best back + lay cell. Same matchMedia breakpoint
  // used across the app (1024px).
  const [isDesktop, setIsDesktop] = useState(
    () => typeof window !== "undefined" && window.matchMedia("(min-width: 1024px)").matches
  );
  useEffect(() => {
    const media = window.matchMedia("(min-width: 1024px)");
    const update = () => setIsDesktop(media.matches);
    media.addEventListener("change", update);
    return () => media.removeEventListener("change", update);
  }, []);
  const ladderDepth = isDesktop ? 3 : 1;
  const [selectedBet, setSelectedBet] = useState({
    selectionId: "",
    teamName: "",
    check: "",
  });
  const [key, setKey] = useState("");
  const [amountRange, setAmountRange] = useState({
    min: 0,
    max: 0,
    oddsLimit: 0,
    betDelay: 0
  });

  const amountRangeFunc = (obj) => {
    setAmountRange({
      min: Number(obj?.minAmount) || 0,
      max: Number(obj?.maxAmount) || 0,
      oddsLimit: obj.oddsLimit ? obj.oddsLimit : 0,
      betDelay: obj?.betDelay
    });
  };

  useEffect(() => {
    if (details?.gameType == "soccer") {
        if (marketName !== "Match Odds") {
          let obj = profileData?.matchSetting?.find((res) => {
            return res?.type == "over_under";
          });
          if (!isEmpty(obj)) {
            amountRangeFunc(obj);
          }
        } else {
          let obj = profileData?.matchSetting?.find(
            (res) =>
              res?.type == "betFaire" &&
              (profileData?.arrayCheck == "details"
                ? true
                : res?.sportType == details?.gameType)
          );
          if (!isEmpty(obj)) {
            amountRangeFunc(obj);
          }
        }
      } else {
        let result = profileData?.matchSetting?.find((res) => {
          return res?.type == marketName;
        });
        if (!isEmpty(result)) {
          let obj = result;
          if (!isEmpty(obj)) {
            amountRangeFunc(obj);
          }
        } else {
          let obj = profileData?.matchSetting?.find(
            (res) =>
              res?.type == "betFaire" &&
              (profileData?.arrayCheck == "details"
                ? true
                : res?.sportType == details?.gameType)
          );
          if (!isEmpty(obj)) {
            amountRangeFunc(obj);
          }
        }
      }
  }, [marketName, profileData, user, details?.gameType]);

  const disabledCheck = () => {
    if (details.matchOdds == "off") {
      return "disabled";
    } else if (amountRange?.oddsLimit == 0) {
      return "disabled";
    } else {
      return "";
    }
  };

  let check = disabledCheck();

  const [popupMessage, setPopMessage] = useState(false);

  const temp = () => {};
  return (
    <>
      {/* Hide the decorative green/red win/loss arrow in the match-detail
          market rows (the ::before on .to-win / .to-lose). */}
      <style>{`
        .market-selection-row .to-win::before,
        .market-selection-row .to-lose::before,
        .market-selection-row .win::before,
        .market-selection-row .lose::before { content: none !important; display: none !important; background-image: none !important; width: 0 !important; margin: 0 !important; }
      `}</style>
      <div
        id="marketBetsWrap"
        className={`bets-wrap asiahadicap ${check} ${
          betDelay ? "cooldown" : ""
        }`}
        // style={{ paddingBottom: details?.premiumFancy !== "on" ? "20vw" : "" }}
      >
        <MarketLimits min={amountRange.min} max={amountRange.max} depth={ladderDepth} />
        {selections?.length > 0 &&
          selections?.map((item, index) => {
            const filter_odds_back = back_odds?.filter(
              (todd) => todd.ri === item?.SelectionId
            );
            const filter_odds_lay = lay_odds?.filter(
              (todd) => todd.ri === item?.SelectionId
            );
            let disabelBack = "lockBackBets" in item  ? item?.lockBackBets : false;
            let disabelLay = "lockLayBets" in item  ? item?.lockLayBets : false;
        
            return (
              <React.Fragment key={item.SelectionId}>
                <dl className="market-selection-row" style={{
                  ...marketRowStyles.row,
                  ...(isDesktop ? { gridTemplateColumns: "minmax(0, 1fr) repeat(6, 9%)" } : {}),
                }}>
                  <dt style={marketRowStyles.selection}>
                    <h4 style={marketRowStyles.name}>{item.RunnerName}</h4>
                    <ul style={marketRowStyles.positions}>
                      {Math.abs(item.position) != 0 &&
                        !isNaN(Math.abs(item.position)) && (
                          <li
                            id="withBet"
                            class={item.position <= 0 ? "lose" : "win"}
                            style={{ display: "list-item" }}
                          >
                            {parseFloat(Math.abs(item.position)).toFixed(2)}
                          </li>
                        )}
                      {betSelectionObj?.priceToogle &&
                        betSelectionObj?.priceToogleType == "odds" &&
                        (betSelectionObj?.betType == "betFair" ||
                          betSelectionObj?.betType == "tie") &&
                        Math.abs(item.newPosition) != 0 &&
                        !isNaN(Math.abs(item.newPosition)) && (
                          <li
                            id="withBet"
                            class={item.newPosition <= 0 ? "to-lose" : "to-win"}
                            style={{ display: "list-item" }}
                          >
                            ({" "}
                            {parseFloat(Math.abs(item.newPosition)).toFixed(2)})
                          </li>
                        )}
                    </ul>
                  </dt>
                  {/* <dd
                    id="suspend"
                    className="suspend"
                    style={{ display: "flex" }}
                  >
                    <p>Suspend</p>
                  </dd> */}
                  {/* <dd
                    id="closed"
                    className="suspend"
                    style={{ display: "flex" }}
                  >
                    <p>Closed</p>
                  </dd> */}
                  {/* <dd
                    id="nonRunner"
                    className="suspend"
                    style={{ display: "none" }}
                  >
                    <p>Non Runner</p>
                  </dd> */}
                  {/* {Math.abs(item.position) != 0 &&
                    !isNaN(Math.abs(item.position)) && (
                      <ul id="winLoss" style={{marginBottom: "0", paddingLeft:"0"}}>
                        <li
                          id="withBet"
                          class={item.position <= 0 ? "to-lose" : "to-win"}
                          style={{ display: "list-item" }}
                        >
                          ( {parseFloat(Math.abs(item.position,newPosition)).toFixed(2)})
                        </li>
                      </ul>

                    )} */}
                  {/* {console.log('betFairMs---', betFairMs)} */}
                  {betFairMs != 1 && (
                    <dd className="suspend-fancy" style={{
                      ...marketRowStyles.suspension,
                      ...(isDesktop ? { width: "54%" } : {}),
                    }}>
                      <p style={{ margin: 0, padding: 0, lineHeight: 1.2 }}>
                        {betFairMs == 9
                          ? "Ball Running"
                          : betFairMs == 2
                          ? "In Active"
                          : betFairMs == 3
                          ? "Suspended"
                          : betFairMs == 4
                          ? "Closed"
                          : "Suspended"}
                      </p>
                    </dd>
                  )}
                  <BackandLay
                    compact
                    depth={ladderDepth}
                    back={filter_odds_back || []}
                    lay={filter_odds_lay || []}
                    setSelectedBet={setSelectedBet}
                    item={item}
                    market={""}
                    disabelBack={disabelBack}
                    disabelLay={disabelLay}
                    setKey={setKey}
                    setSlipObj={setSlipObj}
                    index={index}
                    marketName={marketName}
                    details={details}
                    betmode={details.matchOdds}
                    slipObj={slipObj}
                    setCondi={setCondi}
                    handelBetFairPositions={handelBetFairPositions}
                    messaageBox={messaageBox}
                    betType={betType}
                    amountRange={amountRange}
                    resetSelection={resetSelection}
                  />
                </dl>
                {betSelectionObj?.priceToogle &&
                betSelectionObj?.priceToogleType == "odds" &&
                key == item.SelectionId &&
                (betSelectionObj?.betType == "betFair" ||
                  betSelectionObj?.betType == "tie") ? (
                  <Keyboard
                    setSelections={setSelections}
                    details={{ ...details, marketId: marketId }}
                    selectedBet={selectedBet}
                    setSlipObj={setSlipObj}
                    resetSelection={resetSelection}
                    betType={betType}
                    handelPlaceBetfair={handelPlaceBetfair}
                    amountRange={amountRange}
                  />
                ) : (
                  ""
                )}
              </React.Fragment>
            );
          })}
      </div>
    </>
  );
};

export default MatchDetails;